'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './important-numbers.routes';

export class ImportantNumbersComponent {

  constructor(Auth, $uibModal, ImportantNumberService, DTOptionsBuilder, dialogs, $state, $timeout, Config) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    var directoriesConfig = Config.getModuleConfig(Config.Modules.Directories);

    this.navStyle = directoriesConfig.getImportantNumberNavStyle();
    this.categories = directoriesConfig.getImportantNumberCategories();
    this.categoryImage = directoriesConfig.getImportantNumberCategoryIcons();
    this.$uibModal = $uibModal;
    this.dialogs = dialogs;
    this.$timeout = $timeout;

    this.ImportantNumberService = ImportantNumberService;

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "Important Numbers");

    this.isAdmin = Auth.isAdminSync;

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('responsive', true)
      .withOption("order", [[ 1, "asc" ],[2, "asc"]])
      .withOption('buttons',[{
        extend: 'excel',
        title: 'Important Numbers'
      },{
        extend: 'csv',
        title: 'Important Numbers'
      },{
        title: 'Important Numbers',
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'portrait',
        pageSize: 'LETTER'
      },'print'])
      .withBootstrap();

    this.loadData();
  }

  loadData() {
    this.ImportantNumberService.query(data => {
      this.data = data.reverse();
      if (this.currentFilterCat) {
        this.$timeout(() => {
          // Give the datatable some time to update itself
          // After that, set the filter again
          this.setFilter(this.currentFilterCat);
        }, 250);
      }
    }, err => {
      console.log("could not retrieve important numbers from server");
    });
  }

  openModal(_importantNumber) {

    var that = this;
    var importantNumber = {};

    if (!_importantNumber) {
      importantNumber = {
        name: '',
        number: '',
        category: this.currentFilterCat || this.categories[0]
      }
    } else {
      importantNumber = {
        name: _importantNumber.name,
        number: _importantNumber.number,
        category: _importantNumber.category,
        _id: _importantNumber._id
      }
    }

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'importantNumberEdit',
      resolve: {
        importantNumber: function () {
          return importantNumber;
        },
        config: function () {
          return {}
        }
      }
    });

    modalInstance.result.then(
      function (result) {

        if (result._id) {
          that.ImportantNumberService.upsert({id: result._id}, result, () => {
            that.loadData();
          });
        } else {
          that.ImportantNumberService.save(result, createdNumber => {
            that.loadData();
          });
        }

      },
      function () {
      }
    );
  }

  getCount(cat) {
    if (!this.data) 
      return 0;

    return this.data.reduce((acc, obj) => {
      return acc + (obj.category === cat);
    }, 0);
  }

  delete(number) {
    var that = this;

    var numText = "<br/><br/><b>" + number.name + "</b><br/><p>" + number.number + "</p>";

    var dlg = this.dialogs.confirm("Delete Number?", "Do you really want to delete this number?" + numText);
    dlg.result.then(() => {
      // OK delete it
      that.ImportantNumberService.delete({id: number._id},
        () => {
          that.loadData();
        },
        err => {
          alert("Could not delete important number");
        });
    }, () => {
      // Cancel
    });
  }

  setFilter(cat) {
    this.currentFilterCat = cat;
    jQuery("table.dataTable").DataTable().columns(1).search(cat).draw();
  }

}

export default angular.module('conduuApp.importantNumbers', [uiRouter])
  .config(routes)
  .component('importantNumbers', {
    template: require('./important-numbers.html'),
    controller: ImportantNumbersComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/directories/important-numbers/important-numbers.component.js